/* global $:false */

export default class LotSocial {
  static init () {
    Array.from($('.js-lot-social')).map((el) =>
      new LotSocial(el))
  }

  constructor (el) {
    this.el = $(el)
    this.findElements()
    this.setupBindings()
  }

  findElements () {
    this.foldout = $('.js-lot-social__icon')
  }

  setupBindings () {
    this.el.click(event => {
      event.preventDefault()
      this.el.hide()
      this.foldout.show()
    })
  }
}
